module.exports = __webpack_public_path__ + "img/img_logo.a1091674.png";